export const USER_CREDENTIALS_MISSING_2FA_CODE =
  "userCredentialsMissingTwoFactorAuthenticationCode";
